import React, { createContext, useState, useContext } from "react";
import accountService from "./authService"; // Adjust path as needed

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));

  // Use this function in login
  const handleLogin = async (email, password) => {
    const data = await accountService.login(email, password);
    setToken(data.token);
  };

  return (
    <AuthContext.Provider value={{ token, handleLogin }}>
      {children}
    </AuthContext.Provider>
  );
};
